import httpClient from "Api/httpClient";

const END_POINT = "/quotes";

const getQuotes = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getQuote = (quote_id) => {
    if (!quote_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + quote_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printQuote = (quote_id, view_as = null) => {
    if (!quote_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?quote_id=" + quote_id + "&view_as=" + view_as;
    return httpClient.get(SINGLE_END_POINT);
};

const createQuotes = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateQuotes = (payload, quote_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + quote_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteQuotes = (quote_id) => {
    const DELETE_END_POINT = END_POINT + "/" + quote_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const createOrderFromQuote = (payload, quote_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const CONVERT_END_POINT = "/orders/create_from_quote/" + quote_id;
    return httpClient.post(CONVERT_END_POINT, body);
};

export { getQuotes, getQuote, printQuote, createQuotes, updateQuotes, deleteQuotes, createOrderFromQuote };
